  export class Stamplegend {
  id: number;
  description: string;
  positionX: number;
  positionY: number;
  rotation: number;
  fontSize: number;
  fontType: number;
  fontRgbColor: string;
  pageStamp: number;
  stampOn: number;
  active: number;
}
